<template>

<div class="box_all" v-if="localIsVisible" >
  <img src="/img/signimage2.png"  @click="closeComponent" style="height:80vh; object-fit: cover; border-radius: 10px;float: left;">
  <!-- <div class="box_top">
<p style="color: white;font-size: 3vw;font-weight: bold; vertical-align: bottom;margin-left: 2vw;">咨询和报名申请</p>
<div style="color: lightgrey; font-size: 0.7vw;height: 7vw; font-weight: 600; text-align: left; margin-right: 4vw;">
  <p v-html="lxfs"></p> -->
  <!-- <div>官方邮箱/E-mail:</div>
  <div>liaohuxiao@unityuniversity.cn</div>
  <div>官方电话/Tel:</div>
  <div>(+86)13905061719 廖老师</div>
  <div>(+86)17521170532 陶老师</div>
  <div>(+86)18101861991 汤老师</div>
  <div>时间/CST:</div>
  <div>上午10:00-12:00</div>
  <div>下午14:30-18:30</div> -->
<!-- </div>
</div>




<div class="box_buttom">
<div class="box_buttom_left">
    <div style="margin-top: 2vw;">
<div>
        <div class="form-item">
          <div>{{ question[0] }}</div>
          <input v-model="form.username"/>
        </div>
        <div class="form-item">
          <div>{{ question[1] }}</div>
          <input v-model="form.contactInformation"/>
        </div>
        <div class="form-item">
          <div>{{ question[2] }}</div>
          <input v-model="form.courseInterests"/>
        </div>
        <div class="form-item">
          <div>{{ question[3] }}</div>
          <input  v-model="form.businessProjectInterests"/>
        </div>
        <div class="form-item">
          <div>{{ question[4] }}</div>
          <input  v-model="form.EntrepreneurshipIncubationInterests"/>
        </div>

        <div style="font-size: 0px;">
          <div style="margin-right: 0%; width: 100%; text-align: right;">
            <button style="font-size: 1vw;  font-weight: 600; margin-right: 2vw; width: 4vw; height: 2vw;  border-radius:0.5vw;   background-color: lightgray; border: none;" @click="onSubmit" >提交</button>
          
        </div>
        </div>
      </div>
    </div>
  </div>
<div class="box_buttom_right">
<img :src="imageurl" style=" height: 100%; object-fit: contain;float: right;">




</div>
</div>
 -->
<!-- <button class="close-button">

    </button> -->
  </div>
    
  </template>
  
  <script>

import { request } from '@/Common/request/request';
import axios from 'axios';

  export default {
    props: {
    isVisible: {
      type: Boolean,
      default: true
    }
  },
    name: 'App',
    data() {
      return {

        lxfs:"",
        imageurl:"",
        localIsVisible: this.isVisible,
        question:[],
        form: {
          username: '',
          contactInformation: '',
          courseInterests: '',
          businessProjectInterests:'',
          EntrepreneurshipIncubationInterests:''
        }
      };
    },
    methods: {

      closeComponent() {
        this.localIsVisible = !this.localIsVisible;
      // 通知父组件子组件的显示状态已改变（如果需要）
         this.$emit('visibility-changed', this.localIsVisible);
    },
      onSubmit() {

        console.log('Form data:', this.form);
        if (this.form.username!="" && this.form.contactInformation!=""){
            const data={
              "name":this.form.username,
              "contactInformation":this.form.contactInformation,
              "courseInterests":this.form.courseInterests,
              "businessProjectInterests":this.form.businessProjectInterests,
              "EntrepreneurshipIncubationInterests":this.form.EntrepreneurshipIncubationInterests
            }
            console.log(data)
            let that = this
            axios.post('http://39.105.131.120:8000/registrationInformation/registrationInformation/', data, {
  headers: {
    'Content-Type': 'application/json'
  }
}).then(function (response) {
    alert("提交成功")
    that.closeComponent()
  })
  .catch(function (error) {
    // 请求失败时处理错误
    console.error(error);
    alert("提交失败请稍后再试")
  });

        }
        else{
          alert("请检查姓名或联系方式是否未填")
        }

      },

    },
    watch: {
    // 监听props的变化，更新本地状态（如果需要）
    isVisible(newVal) {
      this.localIsVisible = newVal;
    }
  },

  mounted() {
    request("registrationInformation/ourContactInformation").then(res => {
      this.lxfs=res.data[0].text
}).catch(err => {
    console.log(err)
    alert("获取失败")
})
  request("registrationInformation/registrationInformationImage").then(res => {
      this.imageurl=res.data[0].image
}).catch(err => {
    console.log(err)
    alert("获取失败")
})
  request('registrationInformation/signinquestion').then(res => {
    for(let i=0;i<res.data.length;i++){
      this.question.push(res.data[i].question)
    }
}).catch(err => {
    console.log(err)
    alert("获取失败")
})
  }
  
  };
  </script>
  

  <style scoped src="@/assets/css/signUp.css">

  </style>
